import { combineReducers } from "redux";
import settings from "./settings/Reducer";
import portalReducer from "./portal/Reducer";
import authReducer from "./auth/Reducer";
import subdomainReducer from "./subdomain/Reducer";
import carritoReducer from "./carrito/Reducer";
const reducers = combineReducers({
  settings,
  portalReducer,
  subdomainReducer,
  carritoReducer,
  authReducer
});

export default reducers;
